import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import io from "socket.io-client";
import { BASE_URL_API, IMG_URL, SOCKET_URL } from "../environment";
import moment from "moment";
import axios from "axios";
import noLogo from "../img/logo01.svg";

const socket = io(SOCKET_URL);

function Conversion() {
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [showFullView, setShowFullView] = useState(true);
  const [messages, setMessages] = useState([]);
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const messagesEndRef = useRef(null);
  const [newMessage, setNewMessage] = useState("");
  const [profile, setProfile] = useState(null);
  const [customers, setCustomer] = useState([]);
  const [mobileno, setMobileNo] = useState("");
  const textareaRef = useRef(null);  
  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto"; 
      textarea.style.height = textarea.scrollHeight + "px"; 
    }
  }, [newMessage]);
  const handleSend = async () => {
    if (newMessage.trim() === "") return;

    try {
      setNewMessage(''); 

      const response = await axios.post(
        BASE_URL_API + "customers/sendmessagetospecificnumber", 
        {
          mobile: mobileno,
          message: newMessage.trim(), 
        }
      );

      if (response.data.status) {
        console.log("Message sent successfully");
        // setMessages(prev => [...prev, { 
        //   text: textContent, 
        //   type: "out",
        //   html: newMessage 
        // }]);
      } else {
        alert("Failed to send message. Please try again.");
      }
    } catch (error) {
      console.error("Error sending message:", error);
      alert("Something went wrong while sending the message.");
      // setNewMessage(newMessage);
    }
  };

  useEffect(() => {
    axios
      .get(BASE_URL_API + "customers/getnewmessages")
      .then((res) => {
        const processedCustomers = res.data.data.map(customer => ({
          ...customer,
          unread: !customer.replied && customer.type !== 'outgoing',
          unreadCount: "New",
          time: new Date(customer.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        }));
        setCustomer(processedCustomers);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);
  const handleCustomerClick = (customer) => {
    setSelectedCustomer(customer);
    setShowFullView(false);
    fetchMessages(customer.mobile);
    fetchData(customer.mobile);
    setMobileNo(customer.mobile);
    setCustomer(customers.map(c => 
      c._id === customer._id ? {...c, replied: true, unread: false} : c
    ));
  };
  useEffect(() => {
    if (showFullView) {
      const timer = setInterval(() => {
        if (currentMessageIndex < customers.length) {
          setMessages(prev => [...prev, customers[currentMessageIndex]]);
          setCurrentMessageIndex(prev => prev + 1);
        }
      }, 1000); 

      return () => clearInterval(timer);
    }
  }, [showFullView, currentMessageIndex]);
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);
  const fetchMessages = async (mobile) => {
    try {
      const res = await axios.get(BASE_URL_API+"customers/whatsappmessages/"+ mobile);

      if (res.data.status && Array.isArray(res.data.data)) {
        const formattedMessages = res.data.data.map((msg) => ({
          text: msg.message,
          type: msg.type === "incoming" ? "in" : "out",
          time: moment(msg.createdAt).format("h:mm A"),
        }));
        setMessages(formattedMessages);
      }
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
  };
  
  useEffect(() => {
      console.log("checked connection frontend");
      socket.emit("joinRoom", mobileno);
      console.log("j");
      socket.on("newMessage", (data) => {
        console.log("New message from socket:", data);
  
        setMessages((prev) => [
          ...prev,
          {
            text: data.message,
            type: data.type === "incoming" ? "in" : "out",
            time: moment(data.createdAt).format("h:mm A"),
          },
        ]);
      });
  
      return () => {
        socket.off("newMessage");
      };
    }, [mobileno]);

  const fetchData = (mobile) => {
    axios
      .get(BASE_URL_API + "customers/" + mobile)
      .then((res) => {
        //   console.log(res.data[0]);
        setProfile(res.data[0]);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
    };
  return (
    <div className="container-fluid vh-90 d-flex flex-column p-0">
      <div className="col-12 d-flex overflow-hidden p-0 bg-white border rounded">
        {/* Left Sidebar - Always visible */}
        <div
          className={`${showFullView ? 'col-12' : 'col-lg-3 col-12'} border-end p-2`}
          style={{ height: showFullView ? '100vh' : 'auto' }}
        >
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex align-items-center text-success">
              <h5 className='mb-0'>All Messages</h5>
            </div>
          </div>
          <div style={{ overflowY: 'auto', maxHeight: '90vh', scrollbarWidth: 'none' }}>
          {customers.map((customer, index) => (
            <div
              key={index}
              className="p-2 rounded mb-2 d-flex align-items-start"
              style={{ 
                backgroundColor: selectedCustomer?.mobile === customer.mobile ? "#f0e9ff" : "white", 
                cursor: "pointer",
                borderLeft: selectedCustomer?.mobile === customer.mobile ? '4px solid #7e57c2' : '1px solid #e9ecef',
                border: selectedCustomer?.mobile === customer.mobile ? '1px solid #e9ecef' : '1px solid #e9ecef',
                borderRadius: "8px"
              }}
              onClick={() => handleCustomerClick(customer)}
            >
              {/* Left side - Image */}
              <img 
                src={noLogo} 
                alt="img" 
                className="rounded-circle me-3 align-self-start"
                style={{ width: "50px", height: "50px" }}
              />
              
              {/* Middle section - Name and message */}
              <div className="flex-grow-1 me-2">
                <div className="fw-semibold">{customer.customername}</div>
                <div className="small text-muted mt-1 text-truncate" style={{ maxWidth: "200px" }}>
                  <div className="text-muted small">{customer.time}</div>
                </div>
              </div>
              
              {/* Right side - Date and unread count */}
              <div className="d-flex flex-column align-items-end">
                {/* <div className="text-muted small">{customer.date}</div> */}
                {customer.unread && (
                  <div className="mt-1">
                    <span className="badge bg-primary rounded-circle p-1" style={{ 
                      width: "30px", 
                      height: "20px",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "10px"
                    }}>
                      {customer.unreadCount || 1}
                    </span>
                  </div>
                )}
              </div>
            </div>
          ))}
         </div>
        </div>

        {/* Center Chat Panel - Only shown when a customer is selected */}
        {!showFullView && selectedCustomer && (
          <div className="col-lg-6 col-12 d-flex flex-column border-end p-0">
            {/* Header */}
            <div className="border-bottom d-flex align-items-center p-2">
              <img 
                src={noLogo} 
                alt="img" 
                className="rounded-circle me-3"
                style={{ width: "40px", height: "40px" }}
              />
              <div className="fw-semibold">{selectedCustomer.customername}</div>
            </div>

            <div
          className="card-body d-flex flex-column justify-content-between"
          style={{ height: "90vh" }}
        >
          {/* Chat area */}
          <div
            className="flex-grow-1 mb-2 overflow-auto"
            style={{
              minHeight: "300px",
              overflowY: "scroll",
              scrollbarWidth: "none", 
              msOverflowStyle: "none", 
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              {messages.map((msg, index) => (
                <div
                  key={index}
                  className={`d-flex ${
                    msg.type === "in"
                      ? "justify-content-start"
                      : "justify-content-end"
                  }`}
                >
                  <div
                    className={`p-2 rounded ${
                      msg.type === "in"
                        ? "bg-primary text-white"
                        : "bg-success text-white"
                    }`}
                    style={{ maxWidth: "70%" }}
                  >
                    {msg.text}
                  </div>
                </div>
              ))}
              <div ref={messagesEndRef} />
            </div>
          </div>

          {/* Input area */}
          <div
      className="d-flex align-items-end px-3 py-2"
      style={{
        borderRadius: "20px",
        border: '1px solid #ccc',
        backgroundColor: "#f7f7f8",
        width: "100%",
        maxWidth: "800px",
        margin: "0 auto",
      }}
    >
      <textarea
  ref={textareaRef}
  className="form-control border-0 shadow-none"
  placeholder="Type a message..."
  value={newMessage}
  onChange={(e) => setNewMessage(e.target.value)}
  onKeyDown={(e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  }}
  style={{
    resize: "none",
    overflow: "hidden",
    lineHeight: "1.25",
    fontSize: "1rem",
    paddingTop: "4px",
    paddingBottom: "4px",
    backgroundColor: "transparent",
    outline: "none",
    boxShadow: "none",
    boxSizing: "border-box"
  }}
  rows={1}
/>

      <button
        onClick={handleSend}
        style={{
          border: "none",
          background: "transparent",
          color: "#000",
          padding: "0 8px",
          fontSize: "1rem",
          cursor: "pointer",
        }}
      >
        <i className="fa fa-paper-plane"></i>
      </button>
    </div>
        </div>
        
          </div>
        )}

        {/* Right Sidebar - Only shown when a customer is selected */}
        {!showFullView && profile && (
          <div className="col-lg-3 col-12 p-3">
            <div className="text-center mb-3">
              <img 
                src={noLogo} 
                alt="img" 
                className="rounded-circle me-3"
                style={{ width: "50px", height: "50px" }}
              />
              <h5 className="mt-2 mb-1">{profile?.name}</h5>
              {/* <Link to={`/dashboard/customers/${profile?._id}/${profile?.mobile}`} className="text-primary text-decoration-underline small">
                Click here to see Details
              </Link> */}
            </div>

            <div>
              <p className="text-muted mb-1 small">Email</p>
              <p className="fw-semibold">{profile?.email}</p>

              <p className="text-muted mb-1 mt-3 small">Phone Number</p>
              <p className="fw-semibold">{profile?.mobile}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Conversion;